import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import { ReactPlugin } from '@microsoft/applicationinsights-react-js'

const auth0Domain = import.meta.env.VITE_AUTH0_DOMAIN

const reactPlugin = new ReactPlugin()
const appInsights = new ApplicationInsights({
  config: {
    connectionString: import.meta.env.VITE_APPLICATION_INSIGHTS_CONNECTIONSTRING,
    enableCorsCorrelation: true,
    enableAutoRouteTracking: true,
    enableRequestHeaderTracking: true,
    appId: import.meta.env.VITE_APPID,
    correlationHeaderExcludedDomains: [auth0Domain ? auth0Domain : ''],
    extensions: [reactPlugin]
  }
})
if (import.meta.env.VITE_USE_APPLICATION_INSIGHTS_LOGGING === 'true') {
  appInsights.loadAppInsights()
  appInsights.trackPageView() // Manually call trackPageView to establish the current user/session/pageview
}
export { reactPlugin, appInsights }
